import Layout from "../../layout/Layout";
import ProgressBar from "../ProgressBar";
import Hero4Slider from "../slider/Hero4Slider";
import { projectThreeActive, servicesFiveActive } from "../../sliderProps";
import { Link } from 'react-router-dom';  // Keep this for routing
import { Nav, Tab } from "react-bootstrap";
import Slider from "react-slick";
import Header from "../../layout/header/Header";
import TestimonialSlider from "../testimonials";
import SkillsSection from "../skillssection";

import React, { Suspense, lazy } from 'react';

import bgImage from "../../assets/images/slider/slider-bg.jpg"
import aboutthree from "../../assets/images/about/about-three.jpg"
import aboutbgshape from "../../assets/images/background/about-bg-shape.png"
import servicefive1 from "../../assets/images/services/service-five1.jpg"
import servicefive2 from "../../assets/images/services/service-five2.jpg"
import servicefive3 from "../../assets/images/services/service-five3.jpg"
import servicefive4 from "../../assets/images/services/service-five4.jpg"
import servicedesign from "../../assets/images/services/service-five4.jpg"
import servicemanufacture from "../../assets/images/services/service-five4.jpg"
import servicepacking from "../../assets/images/services/service-five4.jpg"
import servicequalitycontrol from "../../assets/images/services/service-five4.jpg"
import servicethree1 from "../../assets/images/services/service-three1.jpg"
import servicethree2 from "../../assets/images/services/service-three2.jpg"
import servicedistribution from "../../assets/images/services/service-five4.jpg"
import servicesupport from "../../assets/images/services/service-five4.jpg"
import consultationsbg from "../../assets/images/about/consultations-bg.png"
import consultations from "../../assets/images/about/consultations.jpg"
import projecttwo1 from "../../assets/images/projects/project-two1.jpg"
import projecttwo2 from "../../assets/images/projects/project-two2.jpg"
import projecttwo3 from "../../assets/images/projects/project-two3.jpg"
import projecttwo4 from "../../assets/images/projects/project-two4.jpg"

import projectthree1 from "../../assets/images/projects/project-three1.jpg"
import projectthree2 from "../../assets/images/projects/project-three2.jpg"
import projectthree3 from "../../assets/images/projects/project-three3.jpg"

import testiauthor1 from "../../assets/images/testimonials/testi-author1.jpg"
import testiauthor2 from "../../assets/images/testimonials/testi-author2.jpg"
import testiauthor3 from "../../assets/images/testimonials/testi-author3.jpg"
import testiauthor4 from "../../assets/images/testimonials/testi-author4.jpg"

import counterbg from "../../assets/images/background/counter-bg.jpg"

import contactformbg from "../../assets/images/background/contact-form-bg.jpg"
import testimonialsfour from "../../assets/images/testimonials/testimonial-four.jpg"
import blog1 from "../../assets/images/blog/blog1.jpg"
import blog2 from "../../assets/images/blog/blog2.jpg"
import blog3 from "../../assets/images/blog/blog3.jpg"
import blog4 from "../../assets/images/blog/blog4.jpg"
import aboutCircle from "../../assets/images/about/about-circle.png"
import aboutCircleText from "../../assets/images/about/about-circle-text.png"
import aboutFour from "../../assets/images/about/about-four.jpg"


const Index4 = () => {
  return (
    <Layout>
      <Header />
      {/* Slider Section Start */}
      <Hero4Slider />
      {/* Slider Section End */}

      {/* About Area start */}
      <section className="about-area-four pt-25 rpt-0 rel z-2">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6">
              <div className="about-four-image rel z-1 mb-65 wow fadeInRight delay-0-2s">
                <div className="about-circle">
                  <img
                    src={aboutCircle}
                    alt="Circle"
                  />
                  {/* <img
                    className="text"
                    src={aboutCircleText}
                    alt="Circle Text"
                  /> */}
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-10">
              <div className="about-four-content mb-65 rel z-1 wow fadeInLeft delay-0-2s">
                <div className="section-title mb-50">
                  <span className="sub-title mb-15">About SOS</span>
                  <h2>Crafting Excellence in Surgical Instruments</h2>
                  <span className="bg-text">About</span>
                </div>
                <p>
                  At Source of Surgical, we take pride in our extensive range of high-quality stainless steel scissors. Our dedicated team of professional engineers and skilled artisans ensures that quality is prioritized at every stage of production—from selecting premium raw materials to final packaging. Each pair of scissors undergoes rigorous quality control to guarantee excellence as our standard.
                </p>
                <p>
                  We specialize in a diverse array of scissors, including:
                </p>
                <ul className="list-style-one my-30">
                  <li>Surgical Scissors</li>
                  <li>Dental Scissors</li>
                  <li>Eye Scissors</li>
                  <li>Plastic Handle Scissors</li>
                  <li>Barber Scissors</li>
                  <li>Nail Scissors</li>
                </ul>
                {/* <p>
                  Our commitment to innovation drives us to explore modern manufacturing techniques, ensuring superior craftsmanship. Every step of our process is meticulously monitored, delivering the highest quality products to our customers.
                </p>

                <Tab.Container defaultActiveKey={"about-tap1"}>
                  <Nav as={"ul"} className="nav nav-pills nav-fill mb-35">
                    <li className="nav-item">
                      <Nav.Link
                        as={"a"}
                        className="nav-link"
                        data-bs-toggle="tab"
                        href="#about-tap1"
                        eventKey="about-tap1"
                      >
                        Exceptional Quality Assurance
                      </Nav.Link>
                    </li>
                    <li className="nav-item">
                      <Nav.Link
                        as={"a"}
                        className="nav-link"
                        data-bs-toggle="tab"
                        href="#about-tap2"
                        eventKey="about-tap2"
                      >
                        Innovative Manufacturing Techniques
                      </Nav.Link>
                    </li>
                  </Nav>
                  <Tab.Content className="tab-content">
                    <Tab.Pane className="tab-pane fade" eventKey="about-tap1">
                      <p>
                        Our scissors undergo strict quality control protocols to ensure unmatched quality in every product.
                      </p>
                      <Link legacyBehavior href="/about">
                        <a className="theme-btn mt-10">
                          Read More <i className="fas fa-long-arrow-right" />
                        </a>
                      </Link>
                    </Tab.Pane>
                    <Tab.Pane className="tab-pane fade" eventKey="about-tap2">
                      <p>
                        Our skilled and experienced team employs modern techniques to ensure superior craftsmanship in all our scissors.
                      </p>
                      <Link legacyBehavior href="/about">
                        <a className="theme-btn mt-10">
                          Read More <i className="fas fa-long-arrow-right" />
                        </a>
                      </Link>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Area end */}

      {/* Skills Area start */}


      <SkillsSection />


      {/* <section className="skills-area">
        <div className="container">
          <div className="row">
            <div className="col-xl-9">
              <div className="skills-content mt-60 mb-70 rmt-0 rel z-1 wow fadeInLeft delay-0-2s">
                <div className="row">
                  <div className="col-lg-7">
                    <div className="section-title mb-55">
                      <span className="sub-title mb-15">
                        Skills &amp; Experience
                      </span>
                      <h2>Small Enough to Care, Big Enough to Succeed</h2>
                      <span className="bg-text">Skills</span>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4 col-md-6">
                    <div className="circle-progress-item bgc-secondary text-white">
                      <div className="progress-content one">
                        <ProgressBar value={1500} color="#ffff" />
                      </div>
                      <h4>Instruments Manufactured</h4>
                      <p>
                        Over 1,500 instruments manufactured, ensuring precision in every piece.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="circle-progress-item bgc-primary text-white">
                      <div className="progress-content two">
                        <ProgressBar
                          value={995} // The actual number representation of 995 clients satisfied
                          color="#ffff"
                          emptyFill={"#fff"}
                        />
                      </div>
                      <h4>Client Satisfaction</h4>
                      <p>
                        995 out of 1,000 clients satisfied with our products and services.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="circle-progress-item bg-white">
                      <div className="progress-content three">
                        <ProgressBar
                          value={25} // Number representation of years of experience
                          color="#000"
                          emptyFill={"#000"}
                        />
                      </div>
                      <h4>Years of Experience</h4>
                      <p>
                        25 years of expertise in manufacturing top-quality surgical instruments.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="skills-bg"
          style={{
            backgroundImage: `url(${counterbg})`,
          }}
        />
      </section> */}
      {/* Skills Area end */}


      {/* Project Area Four Start */}
      <section className="project-area-four rel z-2" style={{marginTop:"5rem"}}>
        <div className="container-fluid container-height">
          <div className="row section-height">
            <div className="col-xl-9">
              <div className="skills-content mt-60 mb-70 rmt-0 rel z-1 wow fadeInLeft delay-0-2s">
                <div className="row">
                  <div className="col-lg-7">
                    <div className="section-title mb-55 section-title-left-margin">
                      <span className="sub-title mb-15">
                        Production Process Line
                      </span>
                      <h2>State of the art facilities</h2>
                      <span className="md-text">Production</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Slider {...projectThreeActive} className="project-three-active">
            <div className="project-item-three wow fadeInUp delay-0-2s">
              <img
                src={projectthree1}
                alt="Projects"
              />
              <div className="content">
                <span className="category">IT Consulting</span>
                <h4>
                  <Link legacyBehavior href="project-details">
                    Product Engineering
                  </Link>
                </h4>
              </div>
              <Link legacyBehavior href="/project-details">
                <a className="detail-btn">
                  <i className="flaticon-arrow" />
                </a>
              </Link>
            </div>
            <div className="project-item-three big-item wow fadeInUp delay-0-4s">
              <img
                src={projectthree2}
                alt="Projects"
              />
              <div className="content">
                <span className="category">IT Consulting</span>
                <h4>
                  <Link legacyBehavior href="project-details">
                    Product Engineering
                  </Link>
                </h4>
              </div>
              <Link legacyBehavior href="/project-details">
                <a className="detail-btn">
                  <i className="flaticon-arrow" />
                </a>
              </Link>
            </div>
            <div className="project-item-three wow fadeInUp delay-0-6s">
              <img
                src={projectthree3}
                alt="Projects"
              />
              <div className="content">
                <span className="category">IT Consulting</span>
                <h4>
                  <Link legacyBehavior href="project-details">
                    Product Engineering
                  </Link>
                </h4>
              </div>
              <Link legacyBehavior href="/project-details">
                <a className="detail-btn">
                  <i className="flaticon-arrow" />
                </a>
              </Link>
            </div>
            <div className="project-item-three wow fadeInUp delay-0-8s">
              <img
                src={projectthree1}
                alt="Projects"
              />
              <div className="content">
                <span className="category">IT Consulting</span>
                <h4>
                  <Link legacyBehavior href="project-details">
                    Product Engineering
                  </Link>
                </h4>
              </div>
              <Link legacyBehavior href="/project-details">
                <a className="detail-btn">
                  <i className="flaticon-arrow" />
                </a>
              </Link>
            </div>
            <div className="project-item-three big-item wow fadeInUp delay-0-2s">
              <img
                src={projectthree2}
                alt="Projects"
              />
              <div className="content">
                <span className="category">IT Consulting</span>
                <h4>
                  <Link legacyBehavior href="project-details">
                    Product Engineering
                  </Link>
                </h4>
              </div>
              <Link legacyBehavior href="/project-details">
                <a className="detail-btn">
                  <i className="flaticon-arrow" />
                </a>
              </Link>
            </div>
            <div className="project-item-three wow fadeInUp delay-0-2s">
              <img
                src={projectthree3}
                alt="Projects"
              />
              <div className="content">
                <span className="category">IT Consulting</span>
                <h4>
                  <Link legacyBehavior href="project-details">
                    Product Engineering
                  </Link>
                </h4>
              </div>
              <Link legacyBehavior href="/project-details">
                <a className="detail-btn">
                  <i className="flaticon-arrow" />
                </a>
              </Link>
            </div>
          </Slider>
        </div>
      </section>
      {/* Project Area Four End */}

      {/* Testimonial Area Four start */}
      <section className="testimonials-area-four rel z-1">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-5 col-lg-6 ms-lg-auto">
              <div className="testimonials-four-content py-65 rpt-0 rpb-35">
                <div className="section-title mb-35 wow fadeInUp delay-0-2s">
                  <span className="sub-title mb-15">Clients Testimonials</span>
                  <h2>What Our Client’s Say</h2>
                  <span className="bg-text">Says</span>
                </div>
                <TestimonialSlider />
              </div>
            </div>
          </div>
        </div>
        <div
          className="testimonial-four-image"
          style={{
            backgroundImage: `url(${testimonialsfour})`,
          }}
        />
      </section>


      {/* Testimonial Area Three end */}

    </Layout>
  );
};
export default Index4;
